<template>
    <div class="d-flex justify-content-between flex-column h-100">
        <div>
            <h4 class="text-primary mt-0 mb-3" tabindex="0">{{trans('courses.word-hunter.conclusion_title')}}</h4>
            <p v-html="trans('courses.word-hunter.conclusion_message')" />
        </div>
        <div class="d-flex justify-content-center mt-4 mb-5">
            <img src="/images/celebration.svg" class="w-50" />
        </div>
        <div>
            <div class="d-flex justify-content-end w-100">
                <b-button @click="onClickDone">{{trans('courses.word-hunter.back_to_learning')}}</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ConclusionStep",
        props: {
            currentStep: Number,
            promptId: String,
            trackingData: Object
        },
        methods: {
            onClickDone() {
                trackEvent('WordhunterStep4', this.trackingData);
                this.$emit('hideModal');
            }
        }
    }
</script>